var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 33,
    viewBox: "0 0 15 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79289 32.7071C7.18342 33.0976 7.81658 33.0976 8.20711 32.7071L14.5711 26.3431C14.9616 25.9526 14.9616 25.3195 14.5711 24.9289C14.1805 24.5384 13.5474 24.5384 13.1569 24.9289L7.5 30.5858L1.84315 24.9289C1.45262 24.5384 0.819457 24.5384 0.428932 24.9289C0.0384078 25.3195 0.0384078 25.9526 0.428932 26.3431L6.79289 32.7071ZM6.5 0V1.5H8.5V0H6.5ZM6.5 1.5V16H8.5V1.5H6.5ZM6.5 16V32H8.5V16H6.5Z",
    fill: "url(#paint0_linear_214_2530)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_214_2530",
    x1: 8,
    y1: 1,
    x2: 8,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22092C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F05941"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.9679875799d27de53a999e8e32ff06c7.svg";
export { ForwardRef as ReactComponent };